import React, { useState } from 'react';
import produce from 'immer';

import './simpleCards.css';

import Button from '../../components/Button';
import RangeSlider from '../../components/inputs/RangSlider';

import Result from './Result';
import BackgroundController from '../../controllers/BackgroundController';
import BorderController from '../../controllers/BorderController';
import CardController from '../../controllers/CardController';

// import * as DEFAULT_COLORS from '../../constants/defaultColors';

import CardContext, { defaultCard } from '../contexts/cardStyleContext';
import ContainerStyleContext, { initResultContainerStyleData } from '../contexts/containerStyleDataContext';

////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////

function CardsWithoutText(props) {
  const [cards, setCards] = useState([defaultCard]);
  const componentStyle = { height: window.innerHeight - 128 };
  const [containerStyleData, setContainerStyleData] = useState(initResultContainerStyleData);
  const [bgControllerVisible, toggleBgController] = useState(false); // background style of card container
  const [borderControllerVisible, toggleBorderController] = useState(false); // temp
  const [cardControllerVisible, toggleCardController] = useState(true);
  const [activeCardIndex, setActiveCardIndex] = useState(0);

  const addCard = () => {
    if (cards.length === 0) {
      setCards([defaultCard]);
    } else {
      setCards([...cards, cards[cards.length - 1]]); // add replica of last card
    }
  };

  const deleteCard = () => {
    const tempCards = [...cards];
    tempCards.pop();
    setCards(tempCards);
  };

  const handleDistanceBetweenCards = (e) => { // amount +1 or -1
    const amount = Number(e.target.value);
    const newCards = produce(cards, draftCards => {
      draftCards.forEach((card) => {
        card.margins[1] = amount;
        card.style.margin = `${card.margins[0]}px ${card.margins[1]}px ${card.margins[2]}px ${card.margins[3]}px`
      });
    });
    setCards(newCards);
  };

  const onCardClick = (cardIndex) => () => {
    setActiveCardIndex(cardIndex);
    toggleCardController(true);
  };

  const setCardStyle = (cardStyle) => {
    setCards(produce(cards, (draft) => {
      draft[activeCardIndex] = cardStyle;
    }));
  };

  const cardContextValue = { cardStyle: cards[activeCardIndex], setCardStyle };
  const containerStyleContextValue = {containerStyleData, setContainerStyleData};
  return (
    <ContainerStyleContext.Provider value={containerStyleContextValue}>
      <CardContext.Provider value={cardContextValue}>
        <div className="cards-without-text" style={componentStyle}>
          <div style={{ flex: 1, padding: 20, position: 'relative' }} className="card-wo-text-controller">
            <Button label="Adjust Background" onClick={() => toggleBgController(true)} /><br /><br />
            <Button label="Adjust Border" onClick={() => toggleBorderController(true)} />
            <div style={{ marginTop: 40 }}>
              <Button label="Add A Card" onClick={addCard} style={{ marginRight: 10 }} />
              <Button label="Delete Last Card" onClick={deleteCard} disabled={cards.length === 0} />
              {cards.length > 1 && (
                <RangeSlider
                  onChange={handleDistanceBetweenCards}
                  value={cards.length ? cards[cards.length - 1].margins[1] : 0}
                  label={`Adjust Distance Between Cards (${cards.length ? cards[cards.length - 1].margins[1] : 0}px):`}
                />
              )}
            </div>
            {bgControllerVisible && (
              <BackgroundController
                containerStyleData={containerStyleData}
                setContainerStyleData={setContainerStyleData}
                toggleBgController={toggleBgController}
              />
            )}
            {borderControllerVisible && (
              <BorderController
                containerStyleData={containerStyleData}
                setContainerStyleData={setContainerStyleData}
                toggleBorderController={toggleBorderController}
              />
            )}
            {cardControllerVisible && (
              <CardController
                headingLabel={`Modify Card Styles At Position (${activeCardIndex})`}
                toggleCardController={toggleCardController}
              />
            )}
          </div>
          <Result
            containerStyle={containerStyleData.style}
            cards={cards}
            onCardClick={onCardClick}
          />
        </div>
      </CardContext.Provider>
    </ContainerStyleContext.Provider>
  );
}

export {
  defaultCard
};

export default CardsWithoutText;
